import React from "react";
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
  Typography,
  Box,
} from "@mui/material";

interface Props {
  name?: string;
  value: any;
  onChange?: (e: any) => void; // ✅ OPTIONAL किया
  placeholder?: string;
  icon?: React.ReactNode;
  type?: string;
  error?: boolean;
  helperText?: string;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  inputProps?: any;
}

const InputField: React.FC<Props> = ({
  name,
  value,
  onChange,
  placeholder,
  icon,
  type = "text",
  error = false,
  helperText = "",
  label,
  required = false,
  disabled = false,
  inputProps
}) => {
  return (
    <FormControl fullWidth size="small" error={error} sx={{ flex: 1 }}>
      {/* 🔥 LABEL */}
      {label && (
        <Typography sx={{ fontSize: 13, mb: 0.5 }}>
          {label}
          {required && (
            <Box component="span" sx={{ color: "red", ml: 0.5 }}>
              *
            </Box>
          )}
        </Typography>
      )}

      <OutlinedInput
        name={name}
        value={value || ""}
        onChange={onChange || (() => {})} // ✅ SAFE FALLBACK
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        inputProps={inputProps}
        startAdornment={
          icon ? (
            <InputAdornment position="start">{icon}</InputAdornment>
          ) : undefined
        }
        sx={{
          borderRadius: "12px",
          backgroundColor: "#f8fafc",
          height: "44px",
        }}
      />

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default InputField;